export default {
  pageTitle: 'Microsite',
  manageTitle: 'Microsite',
  editorTitle: 'Page editor',
  manageTip: 'Manage H5 pages here. Click Edit to open the visual editor.',
  manageHelpTitle: 'About',
  manageHelpDesc: 'Add pages and set a home page. Click Confirm in the page editor to save; visitors open pages by pageId.',
  backToPageList: 'Back to pages',
  editPage: 'Edit',
  renamePage: 'Rename',
  renameSuccess: 'Page renamed',
  pageCreated: 'Page created',
  pageRemoved: 'Page deleted',
  setHomeSuccess: 'Set as home page',
  pageNotFound: 'Page not found',
  previewHome: 'Preview home',
  pagePreviewUrl: 'Page URL',
  colTitle: 'Title',
  colPageId: 'Page ID',
  colHome: 'Home',
  colComponents: 'Blocks',
  colActions: 'Actions',
  paletteTitle: 'Components',
  pageListTitle: 'Pages',
  addPage: 'Add page',
  homeTag: 'Home',
  setHome: 'Set home',
  removePage: 'Delete',
  propsTitle: 'Properties',
  groupBasic: 'Basic',
  groupLayout: 'Layout',
  groupRegistration: 'Registration',
  groupMeetingList: 'Meetings',
  groupSpecial: 'Special',
  tabEdit: 'Edit',
  tabPage: 'Page',
  tabProps: 'Props',
  pageStyleTitle: 'Page settings',
  showComponent: 'Show',
  dragSort: 'Drag to reorder',
  canvasEffectTitle: 'Preview',
  selectNodeHint: 'Select a component on the canvas',
  canvasTitle: 'Preview',
  canvasEmpty: 'Add components from the left',
  preview: 'Preview',
  previewDialogTitle: 'Page preview',
  previewDialogTip: 'Scan the QR code or copy the link to open the H5 page',
  copyPreviewLink: 'Copy link',
  copyPreviewLinkSuccess: 'Link copied',
  copyPreviewLinkFailed: 'Copy failed',
  openPreviewInBrowser: 'Open in browser',
  previewUrl: 'Home URL',
  saveSuccess: 'Saved',
  saveFailed: 'Save failed. Please try again.',
  pageNamePrompt: 'Page name',
  newPageDefaultName: 'New page',
  removePageConfirm: 'Delete this page?',
  keepOnePage: 'Keep at least one page',
  deco: {
    tabDecor: 'Home decoration',
    tabPages: 'Function pages',
    saveDeco: 'Save decoration',
    saveSuccess: 'Decoration saved',
    intro: 'Configure the mobile event page: background → blocks → link each slot to a page.',
    pagesIntro: 'Manage all pages. Built-in pages link to system features; custom pages are editable.',
    /** deco-studio three-pane workspace */
    compPanel: 'Components',
    layoutSection: 'Entry layouts',
    basicSection: 'Basic',
    toolSection: 'Tools',
    compDisabledHint: 'Coming soon',
    pageSettings: 'Page settings',
    tabTitleBar: 'Title bar',
    tabContent: 'Content',
    tabLogo: 'Footer logo',
    pageTitleLabel: 'Page title',
    showTitleLabel: 'Show title',
    titleColorLabel: 'Title color',
    titleColorBlack: 'Dark',
    titleColorWhite: 'Light',
    bgColorLabel: 'Background color',
    contentOffsetLabel: 'Content offset',
    contentOffsetHint: 'Shift content down to reveal more of the top background',
    quickAddLayout: 'Quick-add entry layout',
    layout1: '1 large + 2 small',
    layout2: '2 columns',
    layout3: '3 columns',
    layout4: 'Full-width entry',
    compCarousel: 'Carousel',
    compSingleImage: 'Image',
    compNav: 'Nav',
    compImageCube: 'Image cube',
    compInfoCard: 'Info card',
    compButtonGroup: 'Buttons',
    compTitle: 'Title',
    compVideo: 'Video',
    compMap: 'Map',
    compNews: 'News',
    compCountdown: 'Countdown',
    compDivider: 'Divider',
    compSpacer: 'Spacer',
    compNotice: 'Notice',
    compTextGroup: 'Text group',
    compRichText: 'Rich text',
    compAlert: 'Alert',
    compTimeline: 'Timeline',
    compFloatBtn: 'Float button',
    stepBg: 'Background',
    stepBgHint: '1290×2796px (iPhone Pro Max), JPG/PNG, full-page background',
    stepBlocks: 'Add blocks',
    stepBlocksHint: 'Add layout blocks; order controls display sequence',
    stepEntry: 'Link slots to pages',
    stepEntryHint: 'Pick a page for each slot. Add custom pages under Function pages.',
    stepEntryNeedBlocks: 'Add an entry layout block first',
    stepLogo: 'Footer logo',
    stepLogoHint: 'Brand logo at bottom; PNG with transparency recommended',
    footerLogoDefaultHint: 'If empty, every page (including built-in registration/agenda) uses the system default logo.',
    footerLogoUsingDefault: 'Using default logo',
    saveFooterLogo: 'Save logo',
    footerLogoUnsaved: 'Unsaved changes',
    footerLogoUploadSuccess: 'Logo uploaded — click Save',
    footerLogoUploadFailed: 'Logo upload failed',
    footerLogoSaveSuccess: 'Footer logo saved',
    footerLogoSaveFailed: 'Failed to save footer logo',
    uploadLogoLockedHint: 'Upload custom logo',
    uploadLogoLockedSub: 'Transparent PNG works best',
    logoLockTitle: 'Custom footer logo · Membership perk',
    logoLockSubtitle: 'Not included in your current plan',
    logoLockDesc: 'Upgrade your membership to replace the platform logo with your brand mark on every activity page.',
    logoLockFeat1: 'Upload a custom brand logo (transparent PNG supported)',
    logoLockFeat2: 'Custom caption text under the logo',
    logoLockFeat3: 'Remove the platform mark and highlight your brand',
    logoLockCta: '🔓 Upgrade membership to unlock',
    logoLockFootnote: 'Upgrade under Membership plans, or contact support for a custom plan',
    logoLockComingSoon: 'Please activate a plan that includes this perk',
    optional: 'Optional',
    uploaded: 'Uploaded',
    uploadBg: 'Upload background',
    uploadLogo: 'Upload logo',
    replace: 'Replace',
    removeBg: 'Remove background',
    removeLogo: 'Remove logo',
    logoTextLabel: 'Caption below logo (optional)',
    logoTextPh: 'e.g. © 2026 Your Company',
    blocksEmpty: 'No blocks yet — pick a layout above',
    blocksAdded: '{n} block(s) added',
    blockIndex: 'Block {n}',
    blockSlotCount: '{n} slot(s)',
    tpl1: '1 large + 2 small',
    tpl2: '2 columns',
    tpl3: '3 columns',
    tpl4: 'Full width',
    slotLeftBig: 'Large left',
    slotTopRight: 'Top right',
    slotBottomRight: 'Bottom right',
    slotLeft: 'Left',
    slotCenter: 'Center',
    slotRight: 'Right',
    slotFullRow: 'Full row',
    slotDefault: 'Slot {n}',
    slotEmpty: '(empty)',
    slotBg: 'Slot {n} image',
    recommendSize: 'Recommended {size}',
    entryNote: 'Link slots to function pages. Edit pages under Function pages list.',
    phonePreview: 'Mobile preview',
    phoneEntrySub: 'Shortcuts',
    phoneBlocksEmpty: 'Add a layout from the left to preview',
    phoneSizeHint: '1290×2796px · blocks stack vertically',
    sectionHome: 'Home',
    sectionBuiltin: 'Built-in ({n})',
    sectionCustom: 'Custom ({n})',
    homePageDefaultName: 'Home',
    homePageDesc: 'Fixed H5 entry page',
    homePageMissing: 'No home page',
    customPageDesc: 'Editable title and content',
    customEmpty: 'No custom pages — click Add page',
    tagFixed: 'Fixed',
    tagBuiltin: 'Built-in',
    tagUnavailable: 'In development, unavailable',
    tagCustom: 'Custom',
    builtinDesc: 'Built-in, not editable; link here via click actions',
    editHomeDeco: 'Decorate home',
    noHomePage: 'Create a home page first',
    defaultActivityTitle: 'Event name',
    builtinReg: 'Registration',
    builtinAgenda: 'Schedule',
    builtinTasks: 'Task lookup',
    builtinSeat: 'Seating',
    builtinHotel: 'Hotel'
  },
  importFromTemplate: 'Import template',
  saveAsTemplate: 'Save as global template',
  quickCreateTitle: 'Quick create',
  quickCreateRecommended: 'Recommended for you',
  quickCreatePresetPending: 'This page preset is not available yet. Pick a template below.',
  quickCreateBlankDefaultName: 'Blank page',
  quickCreate: {
    home: 'Event home',
    register: 'Registration',
    meetingList: 'Meeting list',
    meetingDetail: 'Meeting detail',
    intro: 'About',
    seat: 'Seat lookup',
    photoLive: 'Photo live',
    contact: 'Contact us',
    blank: 'Blank'
  },
  templateDialogTitle: 'Import template',
  templateSaveDialogTitle: 'Save as global template',
  templatePresetLabel: 'Page type',
  templatePresetHint: 'Saves one page from this event as a global template and updates the matching quick-create shortcut.',
  templatePresetHintOther: 'Appears under recommended templates only (quick-create bound templates are hidden there). Category may be left empty.',
  templatePresetRequired: 'Please select a page type',
  templatePresetPageNotFound: 'No matching page to save. Keep a single page in the event, or one page matching this type.',
  templatePreset: {
    other: 'Other'
  },
  templateKeyReadonlyHint: 'Bound to quick-create; read-only',
  templateKeyCustomHint: 'Custom key for recommended templates only',
  templateCategoryEmptyPlaceholder: 'Leave empty',
  templateSelectHint: 'Pages from the template will be appended to this event (existing pages kept).',
  templateColName: 'Name',
  templateColKey: 'Key',
  templateColPages: 'Pages',
  templateColCover: 'Cover',
  templateImportConfirm: 'Import',
  templateImportSuccess: 'Template imported',
  templateImportSuccessCount: '{n} page(s) imported',
  templateImportFailed: 'Import failed. Please try again.',
  templateSaveSuccess: 'Saved as global template',
  templateOverwriteSuccess: 'Template updated',
  templateSaveFailed: 'Save failed. Please try again.',
  templateEmptyPages: 'No microsite pages on this event.',
  templateNoContent: 'All pages are empty. Add content before saving.',
  templateKeyLabel: 'Template key',
  templateKeyPlaceholder: 'e.g. conference_standard_v1',
  templateKeyRequired: 'Template key is required',
  templateKeyInvalid: 'Invalid key (lowercase letters, numbers, underscores, 2–63 chars)',
  templateNameLabel: 'Name',
  templateNamePlaceholder: 'e.g. Standard conference site',
  templateNameRequired: 'Name is required',
  templateDescLabel: 'Description',
  templateCoverLabel: 'Cover URL',
  templateCoverPlaceholder: 'https://...',
  templateCategoryLabel: 'Category',
  templateOverwriteConfirm: 'Template key "{key}" already exists. Overwrite?',
  templateNoList: 'No templates available',
  moveUp: 'Move up',
  moveDown: 'Move down',
  removeNode: 'Remove',
  dragToDelete: 'Drop here to delete',
  dragToDeleteHint: 'Drag the handle to reorder; drop onto the delete zone below the phone to remove',
  actionNone: 'None',
  actionNavigate: 'Go to page',
  actionLink: 'Open URL',
  actionPhone: 'Call phone',
  actionPreviewImage: 'Preview image',
  actionSeatQuery: 'Seat query',
  seatQueryPageUnnamed: 'Unnamed query page',
  seatQueryPagesEmpty: 'No saved seat query pages. Create and save one under Seat editor first.',
  builtinRegMissing: 'No registration form bound to this event',
  builtinRegMissingHint: 'Bind a published form under Registration settings first',
  builtinRegActivityMissing: 'Missing event context for the registration page',
  builtinAgendaMissing: 'Missing event context for the schedule page',
  builtinTasksMissing: 'Missing event context for the task lookup page',
  components: {
    text: 'Text',
    image: 'Image',
    carousel: 'Carousel',
    imageCube: 'Image cube',
    button: 'Button',
    spacer: 'Spacer',
    divider: 'Divider',
    floatButton: 'Float button',
    registrationForm: 'Registration form',
    meetingAgenda: 'Meeting agenda',
    meetingList: 'Meeting list'
  },
  registrationFormOnlyOnRegistrationPage: 'Questionnaire is only available on pages created via Quick create → Registration',
  meetingListOnlyOnMeetingListPage: 'Meeting list is only available on pages created via Quick create → Meeting list',
  meetingListSingleOnly: 'Only one meeting agenda component per page',
  meetingListRequired: 'Add a meeting list component before saving',
  meetingListEditorHint: 'Placeholder in the editor; H5 loads all meetings as cards.',
  meetingListPropsHint: 'Configure per-meeting navigation below after refreshing the list.',
  meetingListEmpty: 'No meetings yet',
  meetingListNoActivity: 'No activity linked; cannot load meetings',
  meetingListLoadFailed: 'Failed to load meetings. Please try again.',
  meetingListActivityNotFound: 'Event not found or unavailable',
  meetingListCardGap: 'Card gap (px)',
  meetingListActionsTitle: 'Meeting navigation',
  meetingListActionsHint: 'Refresh to load meetings, then set click action for each item (page jump includes meetingId).',
  meetingListActionsRefresh: 'Refresh',
  meetingListActionsLoading: 'Loading…',
  meetingListActionsEmpty: 'No meetings. Add them under Schedule first.',
  meetingListActionsNoActivity: 'Missing activity ID',
  meetingListFieldStart: 'Start',
  meetingListExpandCard: 'Expand session',
  meetingListCollapseCard: 'Collapse session',
  meetingListExpandIntro: 'Show more',
  meetingListCollapseIntro: 'Show less',
  meetingListExpand: 'More',
  meetingListCollapse: 'Less',
  meetingListFieldEnd: 'End',
  meetingListFieldRegion: 'Region',
  meetingListFieldAddress: 'Address',
  meetingListFieldLocation: 'Location',
  meetingListFieldIntro: 'Intro',
  specialComponentCannotRemove: 'This system component cannot be removed',
  registrationFormSingleOnly: 'Only one questionnaire component per page',
  registrationFormNeedActivityBind: 'This activity has no linked registration form. Bind one in event settings first.',
  registrationFormBoundToActivityHint: 'Locked to the registration form linked to this activity',
  registrationFormRequired: 'Select a published questionnaire before saving',
  registrationMeetingRequired: 'Select a meeting before saving',
  registrationMeetingSelectLabel: 'Meeting',
  registrationMeetingSelectPlaceholder: 'Select meeting session',
  registrationMeetingSelectHint: 'Optional: select the meeting this registration page applies to',
  registrationMeetingSelected: 'Meeting',
  registrationFormSelectLabel: 'Questionnaire',
  registrationFormSelectPlaceholder: 'Select published questionnaire',
  registrationFormSelectHint: 'Select a published questionnaire in the Props panel',
  registrationFormSelected: 'Selected questionnaire',
  registrationFormHideTitle: 'Hide questionnaire title',
  registrationFormEditFieldsHint: 'Edit fields in Registration → Questionnaire designer',
  registrationFormNotConfigured: 'No questionnaire configured',
  fields: {
    content: 'Content',
    fontSize: 'Font size',
    color: 'Color',
    align: 'Align',
    alignLeft: 'Left',
    alignCenter: 'Center',
    alignRight: 'Right',
    alignJustify: 'Justify',
    imageUrl: 'Image URL',
    imageUrlPh: 'https://... or upload',
    pickImage: 'Choose image',
    clearImage: 'Clear',
    noImage: 'No image',
    imagePending: 'Pending upload',
    imageWidthPercent: 'Image size (%)',
    height: 'Height',
    carouselSlides: 'Slides',
    addSlide: 'Add slide',
    slideIndex: 'Slide {n}',
    removeSlide: 'Remove',
    carouselSlideCount: '{n} slide(s) — edit in Props tab',
    carouselAutoplay: 'Autoplay',
    carouselInterval: 'Interval (ms)',
    carouselIndicator: 'Show indicators',
    carouselLoop: 'Loop',
    imageCubeLayout: 'Layout',
    imageCubeCols2: '2 columns',
    imageCubeCols3: '3 columns',
    imageCubeCols4: '4 columns',
    imageCubeMagic: 'Magic cube',
    imageCubeMagic2: 'Magic cube 2',
    imageCubeImages: 'Images',
    imageCubeGap: 'Gap',
    imageCubeGapX: 'Horizontal gap',
    imageCubeGapY: 'Vertical gap',
    imageCubeItemScale: 'Image size (%)',
    imageCubeItemScaleHint: 'Enlarging one cell shrinks others; content stays inside the cube',
    imageCubeSummary: '{layout} · {n} image(s) — edit in Props tab',
    imageCubeMagicSlot1: 'Magic · left large',
    imageCubeMagicSlot2: 'Magic · top right',
    imageCubeMagicSlot3: 'Magic · bottom right left',
    imageCubeMagicSlot4: 'Magic · bottom right right',
    imageCubeMagic2Slot1: 'Magic 2 · left',
    imageCubeMagic2Slot2: 'Magic 2 · top right',
    imageCubeMagic2Slot3: 'Magic 2 · bottom right',
    addImage: 'Add image',
    removeImage: 'Remove',
    imageIndex: 'Image {n}',
    borderRadius: 'Corner radius',
    buttonText: 'Label',
    buttonPositionMode: 'Position',
    buttonPositionFlow: 'In document flow',
    buttonPositionFixed: 'Fixed on screen',
    buttonPositionFixedHint: 'Pinned to the viewport; does not scroll with page content.',
    buttonPositionAnchor: 'Anchor',
    buttonOffsetX: 'Horizontal inset (px)',
    buttonOffsetY: 'Vertical inset (px)',
    buttonTextColor: 'Text color',
    buttonWidthPercent: 'Width (%)',
    buttonAnchor: {
      bottom_right: 'Bottom right',
      bottom_left: 'Bottom left',
      top_right: 'Top right',
      top_left: 'Top left',
      bottom_center: 'Bottom center',
      top_center: 'Top center',
      center: 'Center'
    },
    bgColor: 'Background',
    pageBackground: 'Background image',
    pageBackgroundHint: 'Covers the full page. Uploaded to OSS on save; applies to editor preview and H5.',
    pageBackgroundColor: 'Background color',
    pageBackgroundColorPh: '#ffffff',
    actionType: 'Action',
    targetPage: 'Target page',
    targetPagePlaceholder: 'Select a page',
    seatQueryPage: 'Seat query page',
    seatQueryPagePlaceholder: 'Select a seat query page',
    builtinPageGroup: 'Built-in',
    customPageGroup: 'Custom pages',
    linkUrl: 'URL',
    phoneNumber: 'Phone number',
    phoneNumberPh: 'e.g. 13800138000 or 400-xxx-xxxx',
    phoneNumberHint: 'On mobile H5, tap opens the dialer. Enter a callable number.',
    previewImageHint: 'Opens this image in a lightbox (can differ from the display image; H5 only)',
    pageTitle: 'Page title',
    marginSection: 'Margin',
    marginX: 'Horizontal margin',
    marginY: 'Vertical margin',
    dividerColor: 'Line color',
    dividerHeight: 'Line thickness',
    floatButtonHint: 'Fixed at the bottom-right corner; does not affect page flow',
    floatButtonHintShort: 'Fixed bottom-right',
    floatButtonImageMode: 'Image uploaded; replaces text button style',
    floatImageWidth: 'Image width',
    floatImageHeight: 'Image height',
    floatOffsetRight: 'Offset from right',
    floatOffsetBottom: 'Offset from bottom'
  }
}
